<template>
    <section class="top-school-section">
				<div class="custom-container">
					<div class="row align-items-center">
						<div class="col-md-12 col-lg-2">
							<div class="slider-section-header">
								<h2>TOP SCHOOLS</h2>
								<p>We are proud of our international and multi-cultural ethos, and the way our community collaborates to make a difference.</p>
								<router-link to="/map-list" class="btn btn-fill">View All</router-link>
							</div>
						</div>
						<div class="col-md-12 col-lg-10">
                            <slick class="sslider top-list-slider" :options="slickOptions">
								<div class="topschools-widget" v-for="item in topschools" :key="item.id">
									<div class="top-schools-img">
										<router-link to="/profile"><img :src="loadImg(item.image)" alt="School" class="img-fluid" /></router-link>
									</div>
									<div class="top-schools-info">
										<h2><router-link to="/profile">{{item.name}}</router-link></h2>
										<ul class="schools-benefit-list">
											<li class="clr-rose">{{item.courses}}</li>
											<li class="clr-blue">{{item.available}}</li>
										</ul>
										<router-link to="/booking" class="btn btn-fill-blue">Book Now</router-link>
									</div>
								</div>
							</slick>
						</div>
					</div>
				</div>
			</section>
</template>

<script>
import topschools from '../../../assets/json/topschools'
const images = require.context('@/assets/img/schools', false, /\.png$|\.jpg$/)

export default {
    data() {
        return {
            topschools: topschools,
             slickOptions: {
                dots: false,
                autoplay:false,
                infinite: true,
                variableWidth: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        }
    },
     methods: {
	  loadImg(imgPath) {
        return images('./' + imgPath)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/TopSchools/index.vue